<script lang="ts">
</script>

<section class = "not-found">
    <article>
        <h1>404</h1>
        <p>The page you were looking for does not exist.</p>
    </article>
</section>

<style lang="scss">
	@import '../styles/colors';

	.not-found {
        width: 100%;
        height: calc(100vh - 4em - 30px);

		display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        h1 {
            margin: 0;
        }
	}
</style>